module.exports = __webpack_public_path__ + "images/emoji/surfer.094ccf3215ce1e507929.png";